import { sortObjectByProperty } from 'lib/helpers/utility';

import { filterFalsyValues } from 'components/practice/charts/ClinicalNote/lib/filterFalsyValues';

export function getEnabledComponents({
  func = () => {},
  type,
  cnDisplaySettings,
  advancedList,
  isCustomForm = false,
  requiredComponents = []
}) {
  const advancedTitles = generateAdvancedTitles(advancedList, cnDisplaySettings, type);

  if (isCustomForm) {
    return sortObjectByProperty(advancedTitles, 'position');
  }

  const enabledComponents = filterFalsyValues(
    func({ cnDisplaySettings, advancedTitles, requiredComponents })
  );

  const sortedComponents = sortObjectByProperty(enabledComponents, 'position');

  return sortedComponents;
}

function generateAdvancedTitles(advancedList, cnDisplaySettings, type) {
  const currentFormSection = cnDisplaySettings?.sections?.[type];
  const advancedForms = advancedList
    ?.map((item) => {
      if (currentFormSection?.[item.custom_title]?.enabled === false) {
        return null;
      }
      return item;
    })
    .filter(Boolean);

  const advancedTitles =
    Array.isArray(advancedForms) &&
    Object.fromEntries(
      advancedForms.map((item) => {
        const title = item?.custom_title;
        return [
          title,
          {
            title: item?.form?.name || item?.name,
            path: title,
            position: currentFormSection?.[item?.custom_title]?.position,
            category: ['hp', 'soap'].includes(type) ? (item?.category ?? 'forms') : 'forms'
          }
        ];
      })
    );
  return advancedTitles;
}

export function assignAdvTitlesToComponent({
  advancedList,
  advancedComponent,
  cnDisplaySettings,
  withStyle = true,
  type
}) {
  const getCurrAdvForm = (key) => advancedList?.find((item) => key === item?.custom_title);

  const advancedTitles = generateAdvancedTitles(advancedList, cnDisplaySettings, type);

  return Object.keys(advancedTitles).reduce((acc, key) => {
    const Component = advancedComponent;
    const currAdvForm = getCurrAdvForm(key);

    acc[key] = (props) => (
      <Component
        currAdvForm={currAdvForm}
        withStyle={withStyle}
        noteType={type}
        customCN={props?.customCN}
        setCustomCN={props?.setCustomCN}
        {...props}
      />
    );
    return acc;
  }, {});
}
